import { QueryClientProvider } from 'react-query';

import { CommandsProvider } from './CommandsProvider';

import type { BaseCommand } from './createCommandDispatchers';
import type { InvalidationReducer } from './useInvalidations';
import type React from 'react';
import type { QueryClient } from 'react-query';

type CommandAndQueryProviderProps<Commands extends BaseCommand, QueryKeys extends string> = {
  queryClient: QueryClient;
  /** Reduce command types to query keys that need to be refetched */
  commandQueryReducer: InvalidationReducer<Commands['type'], QueryKeys>;
  /** Construct commands endpoint */
  createCommandEndpoint: (prospectId: string) => string;
  children: React.ReactNode;
};

/** Extends CommandsProvider and therefore using same CommandsContext */
export const CommandsAndQueryProvider = <Commands extends BaseCommand, QueryKeys extends string>({
  queryClient,
  commandQueryReducer,
  createCommandEndpoint,
  children,
}: CommandAndQueryProviderProps<Commands, QueryKeys>) => {
  return (
    <QueryClientProvider client={queryClient}>
      <CommandsProvider
        invalidationReducer={commandQueryReducer as InvalidationReducer<string, string>}
        createCommandEndpoint={createCommandEndpoint}
      >
        {children}
      </CommandsProvider>
    </QueryClientProvider>
  );
};
